export const NEW_ROOM_ID = 'newRoomId';
export const NEW_BED_ID = 'newBedId';
